//  home page BOB hero Section JS

// Initialization.
$(document).ready(function () {
  let autoplayTimeout = $("#autoplayTimeout").val();
  let smartSpeed = $("#smartSpeed").val();
  $(".hero-owl").owlCarousel({
    items: 1,
    loop: true,
    margin: 0,
    autoplay: true,
    autoplayTimeout: autoplayTimeout,
    autoplayHoverPause: false,
    smartSpeed: smartSpeed,
    dots: false,
    nav: false,
    slideBy: 1,
    rtl: false,
    touchDrag: true,
    mouseDrag: true,
  });
});
